<div [formGroup]="formGroup"
     *ngIf="formGroup">

    <div class="row row--center hidden">
        <div class="col">
            <mat-form-field [hideRequiredMarker]="true"
                            class="col__ mb-0050">
                <mat-label>Response Name</mat-label>
                <input matInput
                       type="text"
                       placeholder="Response Name"
                       formControlName="name"
                       autocomplete="off"
                       appAutofocus>
                <!-- <app-input-error *ngIf="formGroup.controls.email" [formControlItem]="formGroup.controls.email">
                </app-input-error> -->
            </mat-form-field>
        </div>
    </div>
    <div class="row mb-0050"
         *ngIf="isAddress">
        <app-address-form [hideConfirmedCheckbox]="true"
                          formControlName="address"></app-address-form>
    </div>

</div>
